module.exports = __webpack_public_path__ + "img/ic_openlocker.ada6b0d1.svg";